import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../base-query';
import { serializeQueryArgs } from '../serialize-query-args';

export const productsApiSlice = createApi({
  reducerPath: 'productsApiSlice',
  baseQuery,
  endpoints: (builder) => ({
    getProducts: builder.query({
      query: ({ apiManager }) => apiManager.get(),
    }),
  }),
  serializeQueryArgs,
});

export const { useGetProductsQuery } = productsApiSlice;
